module.exports = __webpack_public_path__ + "img/iconEmail.0394520a.svg";